export const safetyCheckAttribute = 'data-dev-safety';
export const safetyCheckClassName = 'dev-safety-class';
export default (propertyName, className = '') => {
    let attrs = {};
    if (process.env.NODE_ENV !== 'production') {
        if (!window.IS_IN_TEST_MODE) {
            className += ' ' + safetyCheckClassName;
            attrs[safetyCheckAttribute] = '1';
        }
    }
    if (window.IS_IN_EDIT_MODE && propertyName) {
        attrs = Object.assign(attrs, {
            className: (className ? className + ' ' : '') + 'epi-editContainer',
            'data-epi-property-name': propertyName,
            'data-epi-use-mvc': 'True',
        });
    }
    else if (className) {
        return (attrs = Object.assign(attrs, { className }));
    }
    return attrs;
};
